module.exports = __webpack_public_path__ + "static/geometric-hedges-974256b24e8de2a5a8d3c3b35030339c.jpg";